import React from 'react'

import { TagProps } from './tag.types'

const Tag = ({
  children,
  type = '',
  active = false,
  size = null,
  className = '',
  onClick = () => void 0
}: TagProps) => {
  const isActive = active ? { active: '' } : {}
  const tagClasses = [type ? `hot-tag--${type}` : '', size ? `hot-tag--${size}` : '', className].join(' ').trim()

  return (
    <hot-tag data-testid="tag-component" class={tagClasses} onClick={onClick} {...isActive}>
      {children}
    </hot-tag>
  )
}

export default Tag
